import * as React from 'react'
import { useEffect, useState } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { getOpportunityStatus } from '@user/components/Opportunities/DetailPage/utils'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import { RequirementsToClose } from '@user/components/RequirementsToClose'
import { useSelectFunnelStagesByType } from '@user/store/salesFunnel/hooks'
import { IScheduleSettingsDetail } from '@user/store/closingRequirements/typings'

interface Props {
  detail: IOpportunityDetail
  canUpdate: boolean
  scheduleSettings?: IScheduleSettingsDetail
}

export const ClosingRequirements: React.FC<Props> = (props) => {
  const { detail, canUpdate, scheduleSettings } = props
  const [status, setStatus] = useState<OPPORTUNITY_STATUSES>()

  const stages = useSelectFunnelStagesByType(
    detail.salesFunnelId,
    'Opportunity',
  )

  useEffect(() => {
    if (stages) {
      const result = getOpportunityStatus(stages, detail.salesFunnelStageId)
      setStatus(result.status)
    }
  }, [detail, stages])

  return (
    <RequirementsToClose
      services={detail.closingRequirements.appointments}
      address={detail.serviceContact.street1}
      branchId={detail.branchId}
      canUpdate={canUpdate}
      entityId={detail.id}
      entityType={ENTITY_TYPES.Opportunity}
      externalLocationId={detail.serviceContact.externalLinkId}
      externalBillToId={detail.billToContact.externalLinkId}
      oppStatus={status}
      requirementsAndCounts={detail.closingRequirements}
      salesFunnelId={detail.salesFunnelId}
      servicesCount={detail.servicesCount}
      referralDiscountId={detail.referralSummary?.referralDiscountId}
      scheduleSettings={scheduleSettings}
      hasValidLocationAddress={detail.hasValidLocationAddress}
      preloadedServiceLocations={detail.locations.serviceLocations}
    />
  )
}

ClosingRequirements.displayName = 'ClosingRequirements'
